// Normalizes any thrown value (axios error, Error, string) into a flat shape
// safe to log. Kept pure + dependency-free so it is trivially unit-testable and
// importable by query-client.ts without import cycles.
export interface NormalizedQueryError {
  message: string;
  status: number | undefined;
  code: string | undefined;
}

export function normalizeQueryError(error: unknown): NormalizedQueryError {
  const e = error as { message?: unknown; code?: unknown; status?: unknown; response?: { status?: unknown } } | null;
  const status = (e?.response?.status ?? e?.status);
  return {
    message: typeof e?.message === 'string' ? e.message : String(error),
    status: typeof status === 'number' ? status : undefined,
    code: typeof e?.code === 'string' ? e.code : undefined,
  };
}
